var MpPageBusinessInsert;

(function() {
    if (!document.querySelector('#vue-body-business-insert')) {
        return;
    }

    Vue.component('multiselect', window.VueMultiselect.default);

    MpPageBusinessInsert = new Vue({
        el: '#vue-body-business-insert',
        mixins: [MpVideoModal],
        data: {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',
            VALIDATION_OK: 1,
            VALIDATION_KO: 0,
            LOCATIONS_PATH: '/country/getLocations',
            FORM_URL: '/business/insert/type/',

            highlight: '',
            type: TYPE,
            name: '',
            address: '',
            zipCode: '',
            zone: '',
            province: '',
            location: '',
            mail: '',
            phone: '',
            web: '',
            description: '', // Not used
            privacity: false,

            zoneList: JSON.parse(ZONES),
            provinceList: JSON.parse(PROVINCES),
            locationList: [],

            errors: [],
            successMessage: '',
            validated: false,

            isLegalShown: false,
            isInitialized: false,
        },
        computed: {

            getFormURL: function() {
                return this.FORM_URL+this.type;
            },

            availableProvinces: function() {
                var _this = this;
                return this.provinceList.filter(function (item) {
                    return item.zoneId === _this.zone.id;
                });
            },

            provincesActive: function() {
                return this.availableProvinces.length > 0;
            },

            locationsActive: function() {
                return this.locationList.length > 0;
            },

            nameCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.name);
            },
            addressCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.address);
            },
            zipCodeCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.zipCode);
            },
            zoneCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.zone);
            },
            provinceCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.province);
            },
            locationCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.location);
            },
            mailCheck: function() {
                return !this.validated || FormValidator.isEmpty(this.mail) || FormValidator.isValidEmail(this.mail);
            },
            phoneCheck: function() {
                return !this.validated || (!FormValidator.isEmpty(this.phone) && FormValidator.isNumber(this.phone));
            },
            webCheck: function() {
                return !this.validated || FormValidator.isEmpty(this.web) || FormValidator.isValidURL(this.web);
            },
            descriptionCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.description);
            },
            privacityCheck: function() {
                return (!this.validated || this.privacity);
            },
            dataForm: function() {
                return Serializer.serialize({
                    highlight: 0,
                    type: this.type,
                    name: this.name,
                    address: this.address,
                    zip_code: this.zipCode,
                    zone: this.zone.id,
                    province: this.province.id,
                    location: this.location.id,
                    phone: this.phone,
                    mail: this.mail,
                    web: this.web,
                    description: this.description,
                    terms_conditions_check: (this.privacity) ? 1 : 0
                });
            }
        },
        methods: {

            closeLegalModal: function() {
                noScroll.off();
                this.isLegalShown = false;
            },

            showLegalConditions: function(ev) {
                if (ev.target.tagName === 'A') {
                    ev.preventDefault();
                    noScroll.on();
                    this.isLegalShown = true;
                }
            },

            onLocationsLoaded: function(provinceId, response) {
                if (response.status !== 200 || !response.data.locations) {
                    return;
                }

                var i,
                    location,
                    nLocations = response.data.locations.length;

                for (i=0; i<nLocations; i++) {
                    location = response.data.locations[i];
                    location.provinceId = provinceId;
                    this.locationList.push(location);
                }
            },

            onZoneSelected: function(selectedZone, id) {
                this.zone = selectedZone;
            },

            onProvinceSelected: function(selectedProvince, id) {
                axios
                    .post(this.LOCATIONS_PATH, Serializer.serialize({
                        idzone: this.zone,
                        idprovince: selectedProvince.id
                    }))
                    .then(this.onLocationsLoaded.bind(null, selectedProvince.id))
                    .catch(function(error) {
                        console.log(error);
                    });
            },

            cleanErrors: function() {
                this.errors = [];
            },

            addError: function(errorMsg) {
                if (this.errors.length > 0) {
                    return;
                }

                this.errors.push(errorMsg);
            },

            validateForm: function() {
                /// requiredFieldEmpty, mailError & webError & termsConditionsRequired
                /// are globally injected from PHP controller
                var isValid = true;

                this.cleanErrors();
                this.validated = true;

                if (!this.nameCheck) {
                    this.addError(requiredFieldEmpty);
                    isValid = false;
                }

                if (!this.addressCheck) {
                    this.addError(requiredFieldEmpty);
                    isValid = false;
                }

                if (!this.zipCodeCheck) {
                    this.addError(requiredFieldEmpty);
                    isValid = false;
                }

                if (!this.zoneCheck) {
                    this.addError(requiredFieldEmpty);
                    isValid = false;
                }

                if (!this.provinceCheck) {
                    this.addError(requiredFieldEmpty);
                    isValid = false;
                }

                if (!this.locationCheck) {
                    this.addError(requiredFieldEmpty);
                    isValid = false;
                }

                if (!this.mailCheck) {
                    this.addError(requiredFieldEmpty);
                    isValid = false;
                }
                if (!this.phoneCheck) {
                    this.addError(requiredFieldEmpty);
                    isValid = false;
                }
                if (!this.webCheck) {
                    this.addError(requiredFieldEmpty);
                    isValid = false;
                }

                if (!this.privacityCheck) {
                    isValid = false;
                    this.addError(termsConditionsRequired);
                }

                return isValid;
            },

            resetForm: function() {
                this.name = '';
                this.type = TYPE;
                this.name = '';
                this.address = '';
                this.zipCode = '';
                this.zone = '';
                this.province = '';
                this.location = '';
                this.mail = '';
                this.phone = '';
                this.web = '';
                this.description = ''; // Not used
                this.privacity = false;

                this.locationList = [];

                this.validated = false;
                this.cleanErrors();
            },

            onSend: function(response) {
                window.location.href = response.request.responseURL;
            },

            sendForm: function(ev) {
                if (this.validateForm()) {
                    axios
                        .post(this.getFormURL, this.dataForm)
                        .then(this.onSend)
                        .catch(function(error) {
                            console.log(error);
                        });
                }
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
            },
        },

        mounted: function() {
            if (!this.$refs.ssrTypeList.querySelector('.js-type-check:checked')) {
                this.$refs.ssrTypeList.querySelector('input:first-of-type').checked = true;
                this.type = this.$refs.ssrTypeList.querySelector('input:first-of-type').value;
            }

            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {
        }
    });

})();